export default __webpack_public_path__ + "static/media/tetris-silver.c132af0a.svg";